import Vue from 'vue' ;
import Router from 'vue-router';

// 路由组件
import error from '@/pages/error';
import mainFrame from '@/pages/mainFrame'; // 外层架子
import innerFrame from '@/pages/innerFrame'; // 内层架子
import home from '@/pages/home/index';
import login from '@/pages/login/index';


// 人才交易中心
import anchorList from '@/pages/anchor/list';
import companyList from '@/pages/company/list';
import serviceList from '@/pages/service/list';

//系统管理
import leftMenuManager from '@/pages/system/leftMenuManager';
import userManager from '@/pages/system/userManager';
import roleManager from '@/pages/system/roleManager';
import functionManager from '@/pages/system/functionManager';

//公共
import editPwd from '@/pages/commonPage/editPwd'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect:'/login',
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{title:'登录'}
    },
    {
      path: '/mainFrame',
      name: 'mainFrame',
      component: mainFrame,
      children:[
        {
          path: '/404',
          name: 'error',
          component: error,
          meta:{title:'404'}
        },
        {
          path: '/home',
          name: 'home',
          component: home,
          meta:{title:'首页',isShowBread:false,matchLeftKey:'/home'}
        },
        {
          path: '/anchor',
          name: 'anchor',
          component: innerFrame,
          meta:{title:'主播信息库'},
          children:[
            {
              path: 'list',
              name: 'anchorList',
              component: anchorList,
              meta:{title:'主播列表',isShowBread:true,matchLeftKey:'/anchor/list'}
            }
          ]
        },
        {
          path: '/company',
          name: 'company',
          component: innerFrame,
          meta:{title:'企业信息库'},
          children:[
            {
              path: 'list',
              name: 'companyList',
              component: companyList,
              meta:{title:'企业列表',isShowBread:true,matchLeftKey:'/company/list'}
            }
          ]
        },
        {
          path: '/service',
          name: 'service',
          component: innerFrame,
          meta:{title:'人才服务'},
          children:[
            {
              path: 'list',
              name: 'serviceList',
              component: serviceList,
              meta:{title:'邀约列表',isShowBread:true,matchLeftKey:'/service/list'}
            }
          ]
        },
        //公共
        {
            path: '/editPwd',
            name: 'editPwd',
            component: editPwd
        },
        //系统管理
        {
          path:'/system',
          name:'system',
          component: innerFrame,
          meta:{title:"系统管理"},
          children:[
            {
                path: 'leftMenuManager',
                name: 'leftMenuManager',
                component: leftMenuManager,
                meta:{title:'菜单管理',isShowBread:true,matchLeftKey:'/system/leftMenuManager'}
            },
             {
                path: 'userManager',
                name: 'userManager',
                component: userManager,
                meta:{title:'用户管理',isShowBread:true,matchLeftKey:'/system/userManager'}
            },
            {
                path: 'roleManager',
                name: 'roleManager',
                component: roleManager,
                meta:{title:'角色管理',isShowBread:true,matchLeftKey:'/system/roleManager'}
            },
            {
                path: 'functionManager',
                name: 'functionManager',
                component: functionManager,
                meta:{title:'功能配置',isShowBread:true,matchLeftKey:'/system/functionManager'}
            }
          ]

        }

      ]
    },
    {
        path: '*',
        redirect: '/404'
    },

  ]
})
function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++)
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}
router.beforeEach((to, from, next) => {
    // if(window.gtag){
    //   gtag('config', 'xxxx', {'page_path': to.fullPath})
    // }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "人才交易管理后台"
    }
    next();
})
router.afterEach((to, from) => {
    function restartLogin() {
        // Message({
        //     message: "请先登录~",
        //     type: 'warning',
        //     duration: 1500
        // });
        setTimeout(function() {
            router.replace("/login")
        }, 100)
    }
    // console.log(to, from)
    let isLogined = getCookie("isLoginedSZHC")
    console.log("isLogined:"+isLogined)
    if (to.name != 'login' && isLogined != 'y') {
        restartLogin()
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js